import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeviderModel, DeviderType, svgData } from 'simpo-component-library';

@Component({
  selector: 'app-divider-list',
  templateUrl: './divider-list.component.html',
  styleUrls: ['./divider-list.component.scss']
})
export class DividerListComponent {
  constructor(public dialogRef: MatDialogRef<DividerListComponent>,
    private snackbar: MatSnackBar,
  ) { }
  @Input() data: any
  Object = Object
  dividerList = svgData;

  dividerData?: DeviderModel;
  ngOnInit() {
    this.data
    this.dividerData = this.data?.data;
    this.current = this.dividerData?.deviderType;
    console.log(this.dividerData, this.dividerList);
  }
  closeDialog() {
    this.dialogRef.close();
  }
  current: any;
  changeDivider(svgData: any) {
    if (this, this.dividerData)
      this.dividerData.deviderType = svgData;
    this.current = svgData;
    this.snackbar.open(
      `Added divider successfully`,
      'Close',
      {
        duration: 1500
      }
    )
  }
}
